module.exports = __webpack_public_path__ + "img/kangyang.57bc3d5f.png";